export default {
    path: '/shenbi/trial/:shiyong/:yq',
    name: 'Shenbi.Trial',
    component: () => import(/* webpackChunkName: "form" */ '@/views/modules/shenbi/Trial.vue'),
    hiddenInMenu: true,
    meta: {
      title: '神笔试用',
      icon: 'database',
    },
  };
  